<template >
  <div id="app" class="bg-black">  
      <router-view></router-view>
  </div>
</template>
<script>

import { RouterView } from 'vue-router';

export default {
  name: 'App',
  components : {
    RouterView
  },
  mounted(){

  }
};

</script>
<style lang="scss">

.bg-container{
  width:100%;
  height:100%;
  background-color: white;
}


/* GLOBAL DEFAULT FONT */
html, body, #app {
  font-family: 'rubikRegular', sans-serif;
}


h1, h2, h3, .new-card-title, .cards-title {
  font-family: 'Poppins', sans-serif;
}

</style>